import React from 'react';
import { motion } from 'framer-motion';

const PoliticaCookies = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-neutral-900 text-neutral-300 py-32 px-6 md:px-12"
    >
      <div className="max-w-3xl mx-auto">
        
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-12 tracking-tighter">
          Política de Cookies
        </h1>
        
        <div className="space-y-10 leading-relaxed">
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. ¿Qué son las cookies?</h2>
            <p className="mb-4">
              Una cookie es un pequeño archivo de texto que se almacena en su navegador cuando visita casi cualquier página web. Su utilidad es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa página. 
            </p>
            <p>
              Las cookies suelen almacenar información de carácter técnico, preferencias personales, personalización de contenidos, estadísticas de uso, enlaces a redes sociales, acceso a cuentas de usuario, etc.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. ¿Qué cookies utilizamos?</h2>
            <p className="mb-4">
              Siguiendo las directrices de la Agencia Española de Protección de Datos procedemos a detallar el uso de cookies que hace esta web con el fin de informarle con la máxima exactitud posible.
            </p>
            <p className="mb-4">Este sitio web utiliza las siguientes <strong>cookies propias y estrictamente necesarias:</strong></p>
            <ul className="list-disc pl-5 space-y-3 text-neutral-400 bg-neutral-800/50 p-6 rounded-lg border border-neutral-800">
              <li><strong className="text-white">Cookies técnicas:</strong> Son aquellas necesarias para la navegación y el buen funcionamiento de la web (por ejemplo, recordar si ya ha aceptado nuestra política de cookies para no volver a mostrarle el aviso).</li>
              <li><strong className="text-white">Cookies de personalización:</strong> Permiten recordar información para que el usuario acceda al servicio con determinadas características (por ejemplo, el idioma seleccionado).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Desactivación o eliminación de cookies</h2>
            <p className="mb-4">
              En cualquier momento podrá ejercer su derecho de desactivación o eliminación de cookies de este sitio web. Estas acciones se realizan de forma diferente en función del navegador que esté usando.
            </p>
            <p>
              Aquí le dejamos los enlaces a las guías oficiales de los navegadores más populares:
            </p>
            <ul className="list-none space-y-2 mt-4 text-neutral-400">
              <li>- <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer" className="text-[#e14141] hover:underline">Google Chrome</a></li>
              <li>- <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noreferrer" className="text-[#e14141] hover:underline">Mozilla Firefox</a></li>
              <li>- <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer" className="text-[#e14141] hover:underline">Apple Safari</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Notas adicionales</h2>
            <ul className="list-disc pl-5 space-y-3 text-neutral-400">
              <li>First Studio no se hace responsable del contenido ni de la veracidad de las políticas de privacidad que puedan tener los terceros mencionados en esta política de cookies.</li>
              <li>Los navegadores web son las herramientas encargadas de almacenar las cookies y desde este lugar debe efectuar su derecho a eliminación o desactivación de las mismas.</li>
            </ul>
          </section>

        </div>
      </div>
    </motion.div>
  );
};

export default PoliticaCookies;
